/**
 * 仅允许站内相对路径，防止 //evil.com 等开放跳转与钓鱼。
 */
export function getSafeInternalPath(path) {
  if (!path || typeof path !== "string") return null;

  const value = path.trim();
  if (!value.startsWith("/") || value.startsWith("//")) return null;
  if (/[:\\]/.test(value) || value.includes("..")) return null;
  if (!/^\/[\w\-./?=&%#]*$/.test(value)) return null;

  return value;
}

export function navigateSafely(navigate, path) {
  const safePath = getSafeInternalPath(path);
  if (safePath) {
    navigate(safePath);
  }
}

/** 过滤用户文本里危险的伪协议链接 */
export function stripDangerousLinkSchemes(text) {
  if (!text) return text;
  return String(text).replace(/(javascript|vbscript|data)\s*:/gi, "");
}
